import React, { useState } from 'react';

import './Tutorial.scss';

import Mouse from './Asset/mouse.svg';
import Tap from './Asset/tapIcon.svg';
import Close from './Asset/close.svg';

function Tutorial() {
  const [tutorial, setTutorial] = useState(true);

  return (
    <div className={`tutorial ${!tutorial && 'hiddenTutorial'}`}>
      <img className='mouseIcon' src={Mouse} alt='mouse' />
      <img className='tapIcon' src={Tap} alt='tap' />
      <span className='uppercase cervoMd mouseIcon'>Click and drag</span>
      <span className='uppercase cervoMd tapIcon'>Tap and drag</span>
      
      <button 
        className='close_tutorial' 
        onClick={() => setTutorial(false)} 
        aria-label='Close tutorial'
      >
        <img src={Close} alt='close' />
      </button>
    </div>
  );
}

export default Tutorial;
